<template lang="pug">
footer
  p.copyrights
    span.rights &copy; conol,Inc
    span.version Manager Ver.
      el-tag(size="mini" type="info") {{ cuonaManagerVersion }}
    span.version API Ver.
      el-tag(size="mini" type="info") {{ cuonaApiVersion }}
  el-button.footer_menu(size="mini" @click="toggle")
    i(:class="toggleIcons()")
  .submenus
    el-menu(mode="horizontal" :class="toggleMenu()")
      //- el-menu-item(index="1")
      //-   a(href="http://faq.cuona.io/") {{ $t('footer_menus.help') }}
      //- el-menu-item(index="2")
      //-   a(href="http://http://documents.cuona.io/") {{ $t('footer_menus.documents') }}
      el-menu-item(index="3")
        a(href="https://cuona.io/contact") {{ $t('footer_menus.contact') }}
      el-menu-item(index="4")
        a(href="/terms") {{ $t('footer_menus.terms') }}
      el-menu-item(index="5")
        a(href="/privacy") {{ $t('footer_menus.privacy') }}

</template>

<style lang="scss" scoped>
@import "../styles/variables.scss";

footer {
  background: #F9F9F9;
  padding: 0 40px;
  font-size: 13px;

  .copyrights {
    float: left;

    span.rights {
      &:after {
        margin-left: 6px;
        content: "|";
        color: #CCC;
      }
    }

    span.version {
      font-size: 10px;
      display: inline-block;
      margin-left: 6px;
    }
  }
  .footer_menu {
    margin: 10px 0;
    padding: 5px;
    float: right;
  }
}
.submenus {
  overflow: hidden;
  float: right;

  .el-menu {
    background: inherit;
    transition: all .6s ease-in-out;
    border-bottom: none;

    .el-menu-item {
      height: 40px;
      line-height: 40px;
      font-size: 13px;
    }
    .el-menu-item:hover {
      background: none;
    }
  }
}

.show {
  opacity: 1;
  margin-right: 0;
}
.hide {
  opacity: 0;
  margin-right: -700px;
}

.el-menu-item a:hover {
  background: none;
  color: $safe;
}

</style>

<script>
import Version from './../version'
import ApiVersion from './../apiVersion'

export default {
  mixins: [ Version, ApiVersion ],
  data () {
    return {
      isShowMenu: false
    }
  },
  methods: {
    toggle: function() {
      this.isShowMenu = !this.isShowMenu
    },
    toggleIcons: function() {
      return this.isShowMenu ? "el-icon-arrow-left" : "el-icon-arrow-right"
    },
    toggleMenu: function() {
      return this.isShowMenu ? "show" : "hide"
    }
  }
}
</script>
